import { useNavigate, useStore, usePathValidation } from '~hooks'
import { RadioList } from '~components'
import { Values } from './interfaces'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { string, object } from '~utils/validation'
import * as Styled from './styled'
import mobile from 'is-mobile'
import { useEffect } from 'react'

function VehicleType() {
  const navigate = useNavigate()
  const { register: storeRegister, vehicle, update } = useStore()
  const schema = object().shape({
    vehicleType: string().required(),
  })
  const defaultValues = { vehicleType: storeRegister?.vehicleType }
  const lightVehicles = vehicle?.types?.data?.filter?.((item) => item.category === 'leve')
  const mediumVehicles = vehicle?.types?.data?.filter?.((item) => item.category === 'medio')
  const heavyVehicles = vehicle?.types?.data?.filter?.((item) => item.category === 'pesado')
  const {
    handleSubmit,
    register,
    formState: { isValid },
  } = useForm({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema),
  })
  const isMobile = mobile()

  useEffect(() => {
    update({ register: { progress: 30 } })
  }, [update])
  usePathValidation(['cpf', 'plate', 'register.cellphone', 'register.fullName'])

  function onSubmit(values: Values) {
    update({ register: values })
    navigate('/cadastrar/rntrc', { state: { previousPath: '/cadastrar/tipo-veiculo' } })
  }

  return (
    <Styled.Form
      onSubmit={handleSubmit(onSubmit)}
      aria-labelledby="form-vehicle-type-title"
    >
      <Styled.Title id="form-vehicle-type-title">
        Selecione o tipo do veículo
      </Styled.Title>
      <Styled.Row>
        <RadioList
          list={heavyVehicles}
          name="vehicleType"
          title="Pesados"
          register={register}
        />
        <RadioList
          list={mediumVehicles}
          name="vehicleType"
          title="Médios"
          register={register}
        />
        <RadioList
          list={lightVehicles}
          name="vehicleType"
          title="Leves"
          register={register}
          isValid={isValid}
        />
      </Styled.Row>
      {(!isMobile || isValid) && (
        <Styled.Footer>
          <Styled.Button role="button" width="350px" disabled={!isValid}>
            Continuar
          </Styled.Button>
        </Styled.Footer>
      )}
    </Styled.Form>
  )
}

export default VehicleType
